import React from 'react';
import { themeFor, iconFor } from './manualTheme';

export const HelpToc = ({ sections, extra = [] }) => (
  <nav data-testid="help-toc" className="no-print lg:sticky lg:top-24 rounded-xl border border-gray-200 bg-white p-3 text-sm">
    <div className="text-[11px] font-bold uppercase tracking-widest text-gray-500 px-2 mb-1">Contents</div>
    <ul className="space-y-0.5">
      {sections.map((s) => {
        const theme = themeFor(s.colour);
        const Icon = iconFor(s.icon);
        return (
          <li key={s.id}>
            <a href={`#chapter-${s.id}`} data-testid={`toc-${s.id}`} className="flex items-center gap-2 rounded-md px-2 py-1.5 text-gray-700 hover:bg-gray-100 transition-colors">
              <span className={`w-5 h-5 rounded ${theme.accent} text-white inline-flex items-center justify-center shrink-0`}><Icon className="w-3 h-3" /></span>
              <span className="truncate">{s.title}</span>
              <span className="ml-auto text-[11px] text-gray-400">{s.count}</span>
            </a>
          </li>
        );
      })}
      {extra.map((e) => (
        <li key={e.id}><a href={`#${e.id}`} data-testid={`toc-${e.id}`} className="block rounded-md px-2 py-1.5 text-gray-700 hover:bg-gray-100">{e.title}</a></li>
      ))}
    </ul>
  </nav>
);
